function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import RubriqTranslationStatus from './RubriqTranslationStatus';
import WordAddinModal from './WordAddinModal';
import RubriqSearchInput from './RubriqSearchInput';
var RubriqTranslationsHeader = function RubriqTranslationsHeader(_ref) {
  var onTranslateDocument = _ref.onTranslateDocument,
    searchTerm = _ref.searchTerm,
    onSearchChange = _ref.onSearchChange;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    wordAddinModalOpen = _useState2[0],
    setWordAddinModalOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "border-bottom d-flex justify-content-between align-items-center gap-md-4 py-2"
  }, /*#__PURE__*/React.createElement(RubriqSearchInput, {
    value: searchTerm,
    onChange: onSearchChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-md-4 ms-auto"
  }, /*#__PURE__*/React.createElement(RubriqTranslationStatus, null), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn bg-white fw-bold rounded-2 px-3 text-nowrap d-flex align-items-center gap-2 rubriq-word-button",
    onClick: function onClick() {
      return setWordAddinModalOpen(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "word-btn-icon"
  }, "W"), /*#__PURE__*/React.createElement(T, {
    source: "USE RUBRIQ IN WORD"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('translate document'),
    type: "button",
    className: "not-global btn btn-primary rounded-3",
    onClick: function onClick() {
      return onTranslateDocument();
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "translate document"
  }))))), /*#__PURE__*/React.createElement(WordAddinModal, {
    open: wordAddinModalOpen,
    onClose: function onClose() {
      return setWordAddinModalOpen(false);
    }
  }));
};
export default RubriqTranslationsHeader;